import React, {Fragment} from 'react';
import {BlockQuote, Breadcrumb, ScrollTopBtn, SecSubTitle, SecTitle, Seo, TitleWrap} from '../components';
import {
    AboutFive,
    AboutFour, AboutOne, AboutSeven, AboutSix,
    AboutThree, BrandTwo,
    ContactTwo,
    FeatureTwo,
    FooterOne,
    HeaderOneCopy,
    ProcessTwo, TestimonialTwo
} from '../containers';
import productsData from '../data/products.json';
import EVOData from "../data/EVO.json";
import AboutEight from "../containers/Abouts/AboutEight";
import AboutEightWithSideTabs from "../containers/Abouts/AboutEightWithSideTabs";
import AboutTwo from "../containers/Abouts/AboutTwo";
import AboutSevenTextImage from "../containers/Abouts/AboutSevenTextImage";
import ServiceTwoEInvoice from "../containers/Services/ServiceTwoEInvoice";
import AboutFourEInvoice from "../containers/Abouts/AboutFourEInvoice";
import FaqTwo from "../containers/Faqs/FaqTwo";
import ServiceOneEInvoice from "../containers/Services/ServiceOneEInvoice";
import AboutSevenZakta from "../containers/Abouts/AboutSevenZakta";
import ServiceOneEInvoiceKSA from "../containers/Services/ServiceOneEInvoiceKSA";
import FeatureOneEInvoice from "../containers/Features/FeatureOneEInvoice";
import Questions from "../containers/Services/Questions";
import CtaOneEInvoice from "../containers/Ctas/CtaOneEInvoice";



const keyFeatures = [
    {"id": "1", "title": "QR Code Generation",},
    {"id": "2", "title": "UUID, Hash, and Cryptographic Stamp Support",},
    {"id": "3", "title": "Real-Time Integration with ZATCA Portal",},
    {"id": "4", "title": "E-Signatures with Certified Devices",},
    {"id": "5", "title": "Clear Text & XML Invoice Generation",},
    {"id": "6", "title": "Compliance with All Mandatory Fields & Formats",},
    {"id": "7", "title": "Archiving & Retrieval of Issued Invoices",},
    {"id": "8", "title": "Integration with ERP Systems like SAP B1, Oracle, and more",},
]


const aboutSeven1 = {
    image: "images/e-Invoice/e-invoice-zatka.png",
    title: `What is ZATCA E-Invoicing?`,
    desc1: "The Zakat, Tax and Customs Authority (ZATCA) introduced mandatory E-Invoicing in Saudi Arabia to enhance transparency and combat tax evasion. It is being rolled out in two major phases:",
    desc2: "With regulations evolving quickly, it's crucial for businesses to adopt a compliant, future-proof solution.",
    point: [
        <><strong>Phase 1 : </strong>Generation (FATOORA) – Businesses must issue electronic invoices using compliant systems with QR codes, timestamps, and mandatory fields.</>,
            <><strong>Phase 2 : </strong>Integration – Invoices must be cryptographically stamped and submitted in real-time to ZATCA via approved channels.</>
    ],
    isWide:true
}


const aboutSeven2 = {
    image: "images/e-Invoice/e-invoice-6.jpg",
    title: `Who Must Comply?`,
    desc1: "All taxable persons (excluding non-residents) in Saudi Arabia must comply with E-Invoicing regulations. This includes:",
    desc2: "",
    point: [
        "SMEs",
        "Enterprises",
        "Service Providers",
        "Retailers & Wholesalers",
    ],

}


const features = [
    {
        title: "Assessment",
        text: "We evaluate your existing invoicing systems.",
        image: "images/icon/process-2-1.png",
    },
    {
        title: "Implementation",
        text: "We configure your platform for Phase 1 and Phase 2 compliance.",
        image: "images/icon/fe-2-2.png",
    },
    {
        title: "Testing & Certification",
        text: "Optional compliance test submission to ZATCA.",
        image: "images/icon/process-1-2.png",
    },
    {
        title: "Go-Live & Monitoring",
        text: "System goes live with real-time reporting.",
        image: "images/icon/process-1-4.png",
    },
]

const aboutFourData = {
    title: 'Why Choose Our ZATCA Solution?',
    subtitle: 'All Your needs in ZATCA solutions',
    images: [
        "/images/solutions/solutions-1.jpeg",
        "/images/solutions/solutions-2.jpg",
    ],
    points: [
        {
            title: "Certified & Compliant",
            text: "Fully aligned with ZATCA specifications"
        },
        {
            title: "ERP-Friendly",
            text: "Smooth integration with your existing business systems"
        },
        {
            title: "Secure & Scalable",
            text: "Built on secure infrastructure with room for growth"
        },
        {
            title: "End-to-End Support",
            text: "From configuration to maintenance and updates"
        },
        {
            title: "Proven in KSA",
            text: "Trusted by businesses across the Kingdom"
        },
    ]


}

const questions = [
    {
        questionId: 1,
        question: "Do I need to upgrade my hardware to comply with ZATCA? ",
        answer: "No, we provide cloud-based and on-premise solutions that can adapt to your existing infrastructure.",
    },
    {
        questionId: 2,
        question: "Can you help us prepare for Phase 2? ",
        answer: "Absolutely. We handle Phase 2 readiness, including UUID generation, cryptographic stamping, and real-time API submission.",
    },
    {
        questionId: 3,
        question: "Is your solution certified by ZATCA? ",
        answer: "Yes, our platform is fully aligned with ZATCA’s specifications and continuously updated.",
    },
    {
        questionId: 4,
        question: "What if I use SAP Business One? ",
        answer: "We have ready-to-deploy integration packages for SAP B1 to fast-track your compliance.",
    },
]


const ctaData = {
    title:"Let’s Get You ZATCA-Compliant",
    subTitle:"Talk to our experts to prepare your business for seamless compliance.",
    image:'images/e-invoice/e-invoice-8.png',
    buttons:[
        {title:"Schedule a Consultation",path:"/contact"},
        {title:"Contact Us",path:"/contact"},
    ]
}

const EInvoiceKSA = () => (
    <Fragment>
        <Seo title="E-Invoicing for KSA"/>
        <HeaderOneCopy/>
        <Breadcrumb pageName="E-Invoicing for KSA"
                    pageSubTitle={"E-Invoicing Made Simple & Compliant"}
                    pageDesc={"Powerful, scalable solutions for digital invoicing across regions."}
                    bgImage="images/bg/bg-e-invoice.png"/>


        <div className="container space-extra-bottom">
            <TitleWrap className="text-center space-top ">
                <SecSubTitle> Stay Ahead of Regulations with Our ZATCA-Ready E-Invoicing Solution</SecSubTitle>
                <SecTitle className="text-capitalize h1">E-Invoicing in Saudi Arabia (ZATCA Compliance)</SecTitle>
            </TitleWrap>

            <p className="author-degi  text-center"> Saudi Arabia is leading the digital tax transformation in the
                region through the ZATCA-mandated E-Invoicing system. Our platform is fully equipped to help you comply
                with both Phase 1 and Phase 2 requirements—quickly, securely, and seamlessly.</p>

        </div>

        <AboutSevenZakta data={aboutSeven1}/>

        <ServiceOneEInvoiceKSA
            title={"Key Features"}
            data={keyFeatures}

        />

        <AboutSevenZakta data={aboutSeven2} reverse={true}/>

        <FeatureOneEInvoice data={features}/>

        <AboutFour reverse={false} data={aboutFourData} className="space space-top mt-5"/>

        <div className="container">
            <BlockQuote
                text="We were concerned about Phase 2 compliance. Their team not only handled it but made the whole process stress-free. We’re now fully integrated with ZATCA."
                author="Faisal A., Finance Director, Distribution Company, Riyadh"
            />
        </div>

        <Questions className={'space-bottom'} questions={questions}/>


        <CtaOneEInvoice
            data={ctaData}
        />

        <FooterOne/>

        <ScrollTopBtn/>
    </Fragment>
);

export default EInvoiceKSA;